import { remove } from '../index';

export const deleteUser = data => {
  return remove('/users', data);
}; 

//Todo: Remove this with above
export const deleteUserOnRole = data => {
  return remove('/users/delete-user', data);
};